export enum MAILBOX_TYPES {
  INBOX = 'Inbox',
  SENT = 'Sent',
  DRAFT = 'Drafts',
  SPAM = 'Spam',
  TRASH = 'Trash',
  ARCHIVE = 'Archive',
  STARRED = 'starred',
}

export enum RESPONSE_MESSAGE {
  EMAIL_SENT = 'Email is being sent in the background',
  IMAGE_SIZE_EXCEEDED = 'Image size is exceeded',
}

export enum SEND_OPTIONS {
  CC = 'CC',
  BCC = 'BCC',
}

export enum RECEIVER_TYPES {
  TO = 'to',
  CC = 'cc',
  BCC = 'ccc',
}

export enum EMAIL_VIEW_OPTIONS {
  FORWARD = 'Forward',
  REPLY = 'Reply',
  REPLY_ALL = 'Reply All',
  REPORT = 'REPORT SPAM',
  PERM_DELETE = 'DELETE_FOREVER',
}

export enum SELECT_TYPES {
  NONE = 'None',
  ALL = 'All',
  STARRED = 'Starred',
  UNSTARRED = 'Unstarred',
  UNREAD = 'Unread',
  READ = 'Read',
}

export enum TLS_TYPES {
  TLS1 = 'TLSv1.1',
  TLS2 = 'TLSv1.2',
  TLS3 = 'TLSv1.3',
}

export enum MAILBOX_CONFIG_TYPES {
  SMTP = 'SMTP',
  IMAP = 'IMAP',
}

// -DATE -> descending order
export enum SORT_CRITERIA {
  DATE = 'DATE', //Message sent date and time. Ascending
  ARRIVAL = 'ARRIVAL', //Internal date and time of the message.
  CC = 'CC', //The mailbox of the first "cc" address.
  FROM = 'FROM', //The mailbox of the first "from" address.
  SIZE = 'SIZE', // Size of the message in octets.
  SUBJECT = 'SUBJECT',
  TO = 'TO',
  DEC_ARRIVAL = '-ARRIVAL',
  DEC_CC = '-CC',
  DEC_DATE = '-DATE',
  DEC_FROM = '-FROM',
  DEC_SIZE = '-SIZE',
  DEC_SUBJECT = '-SUBJECT',
  DEC_TO = '-TO',
}

export enum MAILBOX_FLAGS {
  SEEN = '\\Seen',
  ANSWERED = '\\Answered',
  FLAGGED = '\\Flagged',
  DELETED = '\\Deleted',
  DRAFT = '\\Draft',
}

export enum MAILBOX_FLAG_ACTIONS {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
}

// the building of search criteria of this basic looks like
// ['ALL']
// [['OR', 'UNSEEN', ['SINCE', 'April 22, 2024']]]
// Note : By default, all criterion are ANDed together.
// You can use the special 'OR' on two criterion to find messages matching either search criteria.
export enum BASIC_MAILBOX_FILTERS {
  ALL = 'ALL',
  ANSWERED = 'ANSWERED',
  DELETED = 'DELETED',
  DRAFT = 'DRAFT',
  FLAGGED = 'FLAGGED',
  NEW = 'NEW',
  SEEN = 'SEEN',
  RECENT = 'RECENT',
  OLD = 'OLD',
  UNANSWERED = 'UNANSWERED',
  UNDELETED = 'UNDELETED',
  UNDRAFT = 'UNDRAFT',
  UNFLAGGED = 'UNFLAGGED',
  UNSEEN = 'UNSEEN',
  OR = 'OR',
}

// All of this requires a search term and should build the search criteria as
// ['FROM', 'example@echonlabs.com']
// ['SINCE', 'August 10, 2024']
// ['LARGER', '10000']
// [['HEADER', 'SUBJECT', 'node-imap']] the word node-imap that doesn't exists in header>subject
// [['!HEADER', 'SUBJECT', 'node-imap']] the word node-imap that exists in header>subject
export enum ADVANCE_MAILBOX_FILTERS {
  BCC = 'BCC',
  CC = 'CC',
  FROM = 'FROM',
  SUBJECT = 'SUBJECT',
  TO = 'TO',
  BODY = 'BODY',
  TEXT = 'TEXT',
  KEYWORD = 'KEYWORD',
  HEADER = 'HEADER',
  // DATE CRITERIA
  BEFORE = 'BEFORE',
  ON = 'ON',
  SINCE = 'SINCE',
  SENTBEFORE = 'SENTBEFORE',
  SENTON = 'SENTON',
  SENTSINCE = 'SENTSINCE',
  // SIZE WISE (Messages with a size larger than the specified number of bytes)
  LARGER = 'LARGER',
  SMALLER = 'SMALLER',
}
